import { Drawer } from "../Drawer";
import { DynamicRecordFormShell, type DynamicRecordFormShellProps } from "./DynamicRecordFormShell";

export type DynamicRecordDrawerProps = Omit<DynamicRecordFormShellProps, "className"> & {
  open: boolean;
  widthClassName?: string;
};

export const DynamicRecordDrawer = ({ onClose, open, widthClassName, ...shellProps }: DynamicRecordDrawerProps) => {
  return (
    <Drawer className={widthClassName} onClose={onClose} open={open}>
      <DynamicRecordFormShell className="h-full w-full" onClose={onClose} {...shellProps} />
    </Drawer>
  );
};

export type { DynamicRecordFormShellProps };
